import { IDataService } from '~/core/interfaces'

export class DataService implements IDataService {}

export const dataService = new DataService()
